import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import { HomeActivityFeed } from 'screens/HomeScreen';
import { VerticalNavigation, ErrorBoundary, Modal, Button } from 'components';
import { useAuthState, useFeatureFlagState } from 'context';
import { useQueryParams, useTranslation } from 'hooks';

import styles from './HomeScreen.module.scss';
import illustration from 'assets/img/celebration-stars.svg';
import { trackInfo, infoMessage } from 'helpers';

export const HomeScreen = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { groupsFeatureFlag } = useFeatureFlagState();
  const { groupLoginGroupId } = useAuthState();
  const showOnboardingModal = !!useQueryParams().get('onboarding-complete');

  useEffect(() => {
    if (!showOnboardingModal && groupsFeatureFlag && groupLoginGroupId) {
      trackInfo(infoMessage.GroupInviteRedirectFromHomeScreen);
      return history.push(`/group/${groupLoginGroupId}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const removeOnboardingModal = () => {
    history.push('/');
  };

  return (
    <>
      {showOnboardingModal && (
        <Modal isOpen={showOnboardingModal} onRequestClose={removeOnboardingModal}>
          <div className={styles.onboardingModal}>
            <img className={styles.onboardingModalStars} src={illustration} alt="" />
            <div className={styles.onboardingModalTitle}>
              {t('home-screen.onboarding-modal.title')}
            </div>
            <div className={styles.onboardingModalDesc}>
              {t('home-screen.onboarding-modal.description')}
            </div>

            <Button type="Primary" onClick={removeOnboardingModal}>
              {t('home-screen.onboarding-modal.show-documents')}
            </Button>
          </div>
        </Modal>
      )}

      <VerticalNavigation />
      <div className={styles.content}>
        <div className={classNames(styles.contentBin, styles.layoutMain)}>
          <div className={styles.MainColumn}>
            <div className={styles.FeedContainer}>
              <ErrorBoundary>
                <HomeActivityFeed />
              </ErrorBoundary>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
